import React, { memo } from 'react';
import { useTheme } from 'emotion-theming';
export var CommunityIcon = /*#__PURE__*/memo(function () {
  var _useTheme = useTheme(),
      secondary = _useTheme.colors.secondary;

  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("style", null, ".prefix__a{fill:".concat(secondary, "}")), /*#__PURE__*/React.createElement("g", {
    className: "prefix__a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15c-.2 0-.3 0-.4-.1-.4-.2-.6-.5-.6-.9v-2h-1v-2h2c.6 0 1 .4 1 1v1l2.4-1.8c.2-.1.4-.2.6-.2 1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3h-6c-1.3 0-2.5.9-2.9 2.2l-1.9-.6C8.8 1.5 10.8 0 13 0h6c2.8 0 5 2.2 5 5v2c0 2.6-2.1 4.8-4.7 5l-3.7 2.8c-.2.1-.4.2-.6.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4M2.2 20h11.6c-.6-1.8-2.8-3-5.8-3s-5.2 1.2-5.8 3zM16 22H0v-1c0-3.5 3.3-6 8-6s8 2.5 8 6v1z"
  }))));
});